<h3 mat-dialog-title>Boleta de Execução</h3>

<div mat-dialog-content>
    
    <div fxLayout="row wrap">

        <form [formGroup]="boletaForm">

            <div formArrayName="ativos">

                <div 
                    fxLayout="row" 
                    fxLayoutAlign="space-between" 
                    *ngFor="let item of ativos.controls; let pointIndex=index" 
                    [formGroupName]="pointIndex"
                >
                    <mat-form-field 
                        appearance="outline" 
                        floatLabel="always" 
                        fxFlex="20"
                    >
                        <mat-label>Tipo</mat-label>
                        <mat-select                             
                            formControlName="tipo"
                            name="tipo"                             
                            required
                        >
                            <mat-option value="C">COMPRA</mat-option>
                            <mat-option value="C">VENDA</mat-option>
                            
                        </mat-select> 
                    </mat-form-field>

                    <mat-form-field appearance="outline" floatLabel="always" fxFlex="25">
                        <mat-label>Ativo</mat-label>
                        <input
                            matInput
                            placeholder="Ticker do ativo"
                            aria-label="Ativo"
                            formControlName="ativo"
                            name="ativo"
                            required
                            minlength="5"
                            style="text-transform: uppercase"
                        >
                    </mat-form-field>
                
                    <mat-form-field appearance="outline" floatLabel="always" fxFlex="25">
                        <mat-label>Quantidade</mat-label>
                        <input 
                            matInput 
                            placeholder="Quantidade" 
                            formControlName="qtd" 
                            required
                            type="number"
                            maxlength="20"
                            style="text-align: right;"
                            (ngModelChange)="montaValor()">                           
                    </mat-form-field>
                
                    <mat-form-field appearance="outline" floatLabel="always" fxFlex="25">
                        <mat-label>Preço Executado</mat-label>
                        <input 
                            matInput 
                            placeholder="Preço Executado" 
                            formControlName="preco_executado" 
                            required
                            currencyMask 
                            [options]="{ prefix: 'R$ ', thousands: '.', decimal: ',' }"
                            maxlength="50"
                            (ngModelChange)="montaValor()">
                    </mat-form-field>

                    <button 
                        fxFlex="3"
                        mat-icon-button  
                        tabindex="2" 
                        (click)="removeAtivo(pointIndex)"
                        color="warn"
                        style="height: 65px;"
                    > 
                        <mat-icon aria-label="Adicionar Novo Ativo">remove_circle_outline</mat-icon>                       
                    </button>    
                </div>
            </div>

            <div fxLayout="row" fxLayoutAlign="space-between" >
                <mat-form-field appearance="outline" floatLabel="always" fxFlex="69">
                    <mat-label>Valor Financeiro</mat-label>
                    <input 
                        matInput 
                        placeholder = "Valor Financeiro"
                        formControlName="valor_financeiro"
                        currencyMask
                        [options]="{ prefix: 'R$ ', thousands: '.', decimal: ',' }"
                        maxlength="50">
                </mat-form-field>
    
                <button 
                    mat-raised-button 
                    color="primary" 
                    (click)="addAtivo()"
                    fxFlex="30"                        
                    style="height: 60px; margin-top: 3px;"
                >
                    <mat-icon aria-label="Adicionar Ativo">add_circle_outline</mat-icon>
                    Adicionar Ativo
                </button>
            </div>           
        </form>
    </div>
</div>

<div mat-dialog-actions>
    <button 
        mat-button 
        tabindex="2" 
        (click)="onNoClick()"
    >
        Cancelar
    </button>
    
    <button 
        mat-button         
        (click)="salvar()" 
        tabindex="-1"
    >
        Salvar
    </button>
</div>